export const DECENTRALIZED_FOLDERS = {
  en: "/templates/collects/decentralized/en",
  fr: "/templates/collects/decentralized/fr",
}

export const DECENTRALIZED_WORKPLACE_FILE_PATHS = {
  en: `${DECENTRALIZED_FOLDERS.en}/inventory_template_local_workplace.en.xlsx`,
  fr: `${DECENTRALIZED_FOLDERS.fr}/inventory_template_local_workplace.fr.xlsx`,
}

export const DECENTRALIZED_EXTERNAL_WORKPLACE_FILE_PATHS = {
  en: `${DECENTRALIZED_FOLDERS.en}/inventory_template_local_workplace_external.en.xlsx`,
  fr: `${DECENTRALIZED_FOLDERS.fr}/inventory_template_local_workplace_external.fr.xlsx`,
}

export const DECENTRALIZED_WORKPLACE_FLEX_FILE_PATHS = {
  en: `${DECENTRALIZED_FOLDERS.en}/inventory_template_local_workplace_description.en.xlsx`,
  fr: `${DECENTRALIZED_FOLDERS.fr}/inventory_template_local_workplace_description.fr.xlsx`,
}

export const DECENTRALIZED_EXTERNAL_WORKPLACE_FLEX_FILE_PATHS = {
  en: `${DECENTRALIZED_FOLDERS.en}/inventory_template_local_workplace_external_description.en.xlsx`,
  fr: `${DECENTRALIZED_FOLDERS.fr}/inventory_template_local_workplace_external_description.fr.xlsx`,
}

export const DECENTRALIZED_NETWORK_FILE_PATHS = {
  en: `${DECENTRALIZED_FOLDERS.en}/inventory_template_local_network.en.xlsx`,
  fr: `${DECENTRALIZED_FOLDERS.fr}/inventory_template_local_network.fr.xlsx`,
}

export const DECENTRALIZED_NETWORK_FLEX_FILE_PATHS = {
  en: `${DECENTRALIZED_FOLDERS.en}/inventory_template_local_network_description.en.xlsx`,
  fr: `${DECENTRALIZED_FOLDERS.fr}/inventory_template_local_network_description.fr.xlsx`,
}

export const DECENTRALIZED_DATA_CENTER_FULL_FILE_PATHS = {
  en: `${DECENTRALIZED_FOLDERS.en}/inventory_template_local_datacenter.en.xlsx`,
  fr: `${DECENTRALIZED_FOLDERS.fr}/inventory_template_local_datacenter.fr.xlsx`,
}

export const DECENTRALIZED_DATA_CENTER_FULL_FLEX_FILE_PATHS = {
  en: `${DECENTRALIZED_FOLDERS.en}/inventory_template_local_datacenter_description.en.xlsx`,
  fr: `${DECENTRALIZED_FOLDERS.fr}/inventory_template_local_datacenter_description.fr.xlsx`,
}
